module.exports = {};

require('/var/lib/jenkins/workspace/auth-ui_Release_0/src/shared_modules/ui-experience-system/forms/src/images/checkmark.svg');
require('/var/lib/jenkins/workspace/auth-ui_Release_0/src/shared_modules/ui-experience-system/forms/src/images/down-arrow.svg');
require('/var/lib/jenkins/workspace/auth-ui_Release_0/src/shared_modules/ui-experience-system/forms/src/images/exclamation.svg');